module.exports = require("contentful");


//////////////////
// WEBPACK FOOTER
// external "contentful"
// module id = 312
// module chunks = 0